/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
import { GetterTree } from 'vuex';
import * as types from '@/store/types';
import { RootState } from '../models';
import { UserState, Gravatar } from './models';

export const getters: GetterTree<UserState, RootState> = {
  [types.GET_USERS](state): UserState['users'] {
    return state.users;
  },

  [types.GET_USER](state): UserState['user'] {
    return state.user;
  },

  [types.GET_LOGIN_STATUS](state): UserState['loginState'] {
    return state.loginState;
  },

  [types.GET_FLOW_OWNERS](state): UserState['flowOwners'] {
    return state.flowOwners;
  },

  [types.GET_SIGNUP_REQUEST_RESULT](state): boolean {
    return state.isSignupRequested;
  },

  [types.GET_FORGET_PASSWORD_REQUEST_RESULT](state): boolean {
    return state.isForgetPassRequested;
  },

  [types.GET_GRAVATARS](state): Gravatar[] {
    return state.gravatars;
  },
};
